import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { z } from 'zod';
import { useAxeptio } from '@/composables/_next/useAxeptio';
import { useDynamicYield } from '@/composables/_next/useDynamicYield';
import { useCart } from '~/composables/useCart';
export default defineNuxtPlugin(function () {
  var _useAxeptio = useAxeptio(),
    onConsent = _useAxeptio.onConsent,
    onConsentChange = _useAxeptio.onConsentChange;
  var _useDynamicYield = useDynamicYield(),
    setOptIn = _useDynamicYield.setOptIn,
    setOptOut = _useDynamicYield.setOptOut;
  var _useCart = useCart(),
    addItemById = _useCart.addItemById;

  /**
   * Schema for product data validation
   */
  var productSchema = z.object({
    sku: z.string({
      required_error: 'SKU is required',
      invalid_type_error: 'Invalid SKU: expected string'
    }),
    urlImg: z.string({
      required_error: 'Image URL is required',
      invalid_type_error: 'Invalid image URL: expected string'
    }),
    productName: z.string({
      required_error: 'Product name is required',
      invalid_type_error: 'Invalid product name: expected string'
    }),
    priceData: z.number({
      required_error: 'Price is required',
      invalid_type_error: 'Invalid price: expected number'
    }).refine(function (val) {
      var _val$toString$split$;
      var decimal = (_val$toString$split$ = val.toString().split('.')[1]) !== null && _val$toString$split$ !== void 0 ? _val$toString$split$ : '';
      return decimal.length <= 2;
    }, {
      message: 'Invalid price: more than 2 decimals not allowed'
    }).refine(function (val) {
      var digits = val.toFixed(2).replace('.', '');
      return digits.length <= 5;
    }, {
      message: 'Invalid price: must be max 5 digits (e.g. 999.99)'
    })
  });
  if (process.client) {
    /**
     * Add product to cart from Dynamic Yield context.
     *
     * @param {string} sku - Product SKU.
     * @param {string} urlImg - Product image URL.
     * @param {number} priceData - Product price.
     * @param {string} productName - Product name.
     */
    window.addToCartFromDY = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(sku, urlImg, priceData, productName) {
        var validation, validData, price;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              validation = productSchema.safeParse({
                sku: sku,
                urlImg: urlImg,
                priceData: priceData,
                productName: productName
              });
              if (validation.success) {
                _context.next = 4;
                break;
              }
              validation.error.errors.forEach(function (err) {
                return console.warn(err.message);
              });
              return _context.abrupt("return");
            case 4:
              validData = validation.data;
              price = {
                value: {
                  centAmount: Math.round(validData.priceData * 100)
                }
              };
              _context.next = 8;
              return addItemById({
                product: {
                  sku: validData.sku,
                  price: price,
                  mainImage: validData.urlImg,
                  name: validData.productName
                },
                quantity: 1,
                showConfirmation: true
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      };
    }();
  }

  /**
   * Initial consent: activate DY if accepted
   */
  onConsent('dynamicyield', function () {
    setOptIn();
  });
  onConsentChange('dynamicyield', function (isAllowed) {
    if (isAllowed) {
      setOptIn();
    } else {
      setOptOut();
      var dyidServerCookie = useCookie('_dyid_server');
      dyidServerCookie.value = null;
    }
  });
});